import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface ISalesPackagePriceModel extends IModel {
  salesPackagePriceId: number;
  salesPackageId: number;
  startDate: string;
  endDate: string;
  price: number;
}

export class SalesPackagePriceModel
  extends Model
  implements ModelRecord<ISalesPackagePriceModel>
{
  salesPackagePriceId: number;
  salesPackageId: number;
  startDate: string;
  endDate: string;
  price: number;
  constructor(params?: Partial<ISalesPackagePriceModel>) {
    super(params);
    this.salesPackagePriceId = defaultTo(params?.salesPackagePriceId, 0);
    this.salesPackageId = defaultTo(params?.salesPackageId, 0);
    this.startDate = defaultTo(params?.startDate, '');
    this.endDate = defaultTo(params?.endDate, '');
    this.price = defaultTo(params?.price, 0);
  }
}
